// extracted by mini-css-extract-plugin
module.exports = {"flex_containerInputSearch":"search_flex_containerInputSearch__2cG_8","searchGameInput":"search_searchGameInput__zL_sr","gamesSearch":"search_gamesSearch__2sQNN"};